export default (function ($) {

    var _instance = {}

    /**
     * Initialize the method
     *
     * @return false
     */
    _instance.init = function () {
        $(document).ready(function () {
            var $label = $(".gfield.checkbox .gfield_checkbox").find("label");
            $label.each(function(){
                $(this).html($(this).text() + '<span class="information js-checkbox-information">i</span>');
            });

            $(document).on("click", ".js-checkbox-information", function(e){
                e.preventDefault();
                var $gfield = $(this).closest(".gfield.checkbox");
                $gfield.toggleClass("checkbox--active");
            });
        });

    };

    return _instance;

})(jQuery)